export interface TourState {
  slotBookModal: boolean;
  slot: { id: number; date: string; time: string } | null;
}

const TourStore = {
  namespaced: true,
  state: {
    slotBookModal: false,
    slot: null,
  } as TourState,
  mutations: {
    saveSlotBook(state: TourState, openModal: boolean) {
      state.slotBookModal = openModal;
    },
    saveSlot(
      state: TourState,
      slot: { id: number; date: string; time: string } | null
    ) {
      state.slot = slot;
    },
  },
  actions: {
    toggleSlotBook({
      commit,
      state,
    }: {
      commit: (mutation: string, payload: any) => void;
      state: TourState;
    }) {
      commit("saveSlotBook", !state.slotBookModal);
    },
    selectSlot(
      {
        commit,
        state,
      }: {
        commit: (mutation: string, payload: any) => void;
        state: TourState;
      },
      slot: { id: number; date: string; time: string } | null
    ) {
      commit("saveSlot", slot);

      return slot;
    },
  },
};

export default TourStore;
